import React from "react";
import DataGrid from "../../../../../../../dataGrid/index";
import PickupInfoGridConfig from "./GridConfig";
import { withUserProfile } from "../../../../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import styles from "./styles";
import { withStyles } from "@material-ui/core";
import SaveAltSharp from "@material-ui/icons/SaveAltSharp";
import { csvFormulaInjectionSanitizer } from "../../../../../../../../utilities/csvUtils";

class PickupInfoGrid extends React.Component {
  constructor(props) {
    super(props);

    this.gridConfig = new PickupInfoGridConfig(this.props.userData.userProfile);
    this.gridApi = {};
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
  };
  exportCSV = () => {
    if (this.gridApi) {
      const params = {
        fileName: `pickupInfoGrid`,
        processCellCallback: (cell) => csvFormulaInjectionSanitizer(cell.value)
      };
      this.gridApi.exportDataAsCsv(params);
    }
  };

  constructStatusBar = () => {
    const {  pieces, weight, bills, hu} = this.props.pickupinfo
    const { classes } = this.props;
    return (
      <>
        <div className={classes.GridFooter}>
          <div className={classes.value}>Total</div>
          <div>
            <span className={classes.label}>Pieces:</span>
            <span className={classes.value}>{pieces}</span>
          </div>
          <div>
            <span className={classes.label}>Weight:</span>
            <span className={classes.value}>{weight}</span>
          </div>
          <div>
            <span className={classes.label}>HUs:</span>
            <span className={classes.value}>{hu}</span>
          </div>
          <div>
            <span className={classes.label}>Shipments:</span>
            <span className={classes.value}>{bills}</span>
          </div>
        </div>
      </>
    );
  };

  render() {
    const data = this.props.pickupinfo?.shipments?.length > 0
      ? this.props.pickupinfo.shipments.slice()
      : [];
    const { classes } = this.props;
    return (
      <React.Fragment>
        <div className={classes.headerStyle}>
          <span className={classes.headerLabel}>Shipment Details</span>
          <SaveAltSharp
            onClick={this.exportCSV}
            className={classes.iconStyle}
          />
        </div>
        <div className={classes.dataGrid}>
          <DataGrid
            defaultColDef={this.gridConfig.config.defaultColDef}
            columnDefs={this.gridConfig.config.columns}
            columnTypes={this.gridConfig.config.columnTypes}
            config={this.gridConfig.config}
            rowSelection={this.gridConfig.config.rowSelection}
            rowDeselection={this.gridConfig.config.rowDeselection}
            rowData={data}
            onGridReady={this.onGridReady}
            onSelectionChanged={this.onSelectionChanged}
            isExternalFilterPresent={true}
            layoutContainer={this.props.glContainer}
            panelLabel={this.constructStatusBar}
          />
        </div>
      </React.Fragment>
    );
  }
}
export default compose(
  withUserProfile,
  withSnackbar,
  withStyles(styles)
)(PickupInfoGrid);
